import CloseIcon from "@mui/icons-material/Close";
import {
  Drawer,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import axios from "axios";
import * as React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { baseURL } from "../../common/api/apiUris";
import {
  useCompany,
  useDealer,
  useDealerCompany,
  useUser,
} from "../../common/hooks";
import { layoutStyle } from "../../pages/layout-ui/style";

export default function AddCompany({
  open,
  setOpen,
  title,
  setRefreshData,
  editValue,
}) {
  const classes = layoutStyle();
  const [binaryImage, setBinaryImage] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedDealerId, setSelectedDealerId] = useState("");
  const [users, setUsers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const { getCompanyApi } = useCompany();
  const { getDealerCompanyApi } = useDealerCompany();
  const { getUser, user } = useUser();
  const { getDealerApi, dealer: dealerData } = useDealer();
  const dealerId = parseInt(localStorage.getItem("cashflow_admin_user_id"));
  let data = new FormData();

  const handleClose = () => {
    setBinaryImage(null);
    setCompanyName(null);
    setOpen(false);
  };

  const defaultValue = {
    companyName: "",
    companyLogo: null,
  };
  const generateInitialValues = (props) => {
    if (editValue) {
      for (const key in defaultValue) {
        if (key in editValue && editValue[key] !== null) {
          if (Array.isArray(defaultValue[key])) {
            defaultValue[key] =
              Array.isArray(editValue[key]) && editValue[key].length > 0
                ? editValue[key]
                : defaultValue[key];
          } else {
            defaultValue[key] = editValue[key];
          }
        }
      }
    }

    return defaultValue;
  };

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: defaultValue,
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    // resolver: yupResolver(schema),
  });
  const onSubmit = async () => {
    data.append("ImageFile", binaryImage);
    data.append("CompanyImage", binaryImage);
    data.append("CompanyImageName", imageName);
    data.append("CompanyName", companyName);
    data.append("Deleted", false);
    if (selectedUserId) {
      data.append("createdBy", selectedUserId);
    }
    if (selectedDealerId) {
      data.append("dealerId", selectedDealerId);
    }
    if (data && title === "Edit Company") {
      data.append("id", editValue?.id);
      axios({
        url: `${baseURL}/Company/Update`,
        data: data,
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          setRefreshData(true);
        })
        .finally(async () => {
          await getCompanyApi();
        });
    } else {
      axios({
        url: `${baseURL}/Company/Create`,
        data: data,
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          setRefreshData(true);
        })
        .finally(async () => {
          await getCompanyApi();
        });
    }
    handleClose();
  };

  useEffect(() => {
    data.delete("ImageFile");
    data.delete("CompanyName");
    data.delete("Deleted");
  }, [open]);

  useEffect(() => {
    if (editValue) {
      setCompanyName(editValue?.companyName);
      setSelectedUserId(editValue?.createdBy || "");
      setSelectedDealerId(editValue?.dealerId || "");
    }
  }, [editValue]);

  useEffect(() => {
    getUser({ limit: 10000, offset: 0 });
    getDealerApi({ limit: 10000, offset: 0 });
  }, [getUser, getDealerApi]);

  useEffect(() => {
    setUsers(user || []);
  }, [user]);

  useEffect(() => {
    setDealers(dealerData || []);
  }, [dealerData]);

  const imageToBinary = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const binaryString = reader.result;
        resolve(binaryString);
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsBinaryString(file);
    });
  };

  const handleCompanyLogo = async (event) => {
    setImageName(event?.timeStamp);
    let file = event.target.files[0];

    try {
      const binaryData = await imageToBinary(file);
      setBinaryImage(file); // Output the binary data to console
    } catch (error) {
      console.error("Error converting image to binary:", error);
    }
  };

  const handleCompanyName = (event) => {
    setCompanyName(event.target.value);
  };

  return (
    <React.Fragment>
      <Drawer
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
        anchor="bottom"
        fullHeight
        style={{ top: "100px ", bottom: "56px !important" }}
        className="DrawerName"
      >
        <DialogTitle
          className={classes.dailogTitle}
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container className={classes.disFlexCenter}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid className={classes.companyForm}>
                <Grid className={classes.compnayFormField}>
                  <InputLabel className={classes.fontSize12}>
                    Company Name
                  </InputLabel>
                  <TextField
                    // error={errors?.companyName}
                    type="text"
                    fullWidth
                    value={companyName}
                    onChange={handleCompanyName}
                  />
                </Grid>
                <Grid className={classes.compnayFormField}>
                  <InputLabel className={classes.fontSize12}>
                    Username
                  </InputLabel>
                  <FormControl fullWidth>
                    <Select
                      value={selectedUserId}
                      onChange={(event) =>
                        setSelectedUserId(event.target.value)
                      }
                      disabled
                      displayEmpty
                      sx={{ minHeight: 45 }}
                    >
                      <MenuItem value="">
                        <em>Select user</em>
                      </MenuItem>
                      {users?.map((user) => (
                        <MenuItem key={user.id} value={user.id}>
                          {user.userName || user.name || user.email}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid className={classes.compnayFormField}>
                  <InputLabel className={classes.fontSize12}>
                    DealerName
                  </InputLabel>
                  <FormControl fullWidth>
                    <Select
                      value={selectedDealerId}
                      onChange={(event) =>
                        setSelectedDealerId(event.target.value)
                      }
                      disabled
                      displayEmpty
                      sx={{ minHeight: 45 }}
                    >
                      <MenuItem value="">
                        <em>Select dealer</em>
                      </MenuItem>
                      {dealers?.map((dealer) => (
                        <MenuItem key={dealer.id} value={dealer.id}>
                          {dealer.dealerName || dealer.name || dealer.email}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid className={classes.compnayFormField}>
                  <InputLabel className={classes.fontSize12}>
                    Company Logo
                  </InputLabel>
                  <TextField
                    error={errors?.companyLogo}
                    type="file"
                    onChange={handleCompanyLogo}
                    fullWidth
                    inputProps={{
                      accept: "image/jpeg, image/png, image/gif, image/bmp",
                    }}
                    // {...register("companyLogo")}
                  />
                </Grid>

                <Button
                  variant="outlined"
                  type="submit"
                  className={classes.fleetListNewButton}
                  autoFocus
                  sx={{ mt: 3, height: "50px" }}
                >
                  {title}
                </Button>
              </Grid>
            </form>
          </Grid>
        </DialogContent>
      </Drawer>
    </React.Fragment>
  );
}
